import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteUser, getUsers } from './_request';
import { useAuth } from '../context/AuthContext';

const Users = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const { authToken, themeMode } = useAuth();
    const isDark = themeMode === 'dark';

    const getAllUser = useCallback(async () => {
      try {
        const response = await getUsers(authToken);
        if (response.Result) {
          setUsers(response.data);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }, [authToken]);

    useEffect(() => {
      getAllUser();
    }, [getAllUser]);

    const deleteAUser = async (id) => {
      if (!window.confirm("Are you sure you want to delete this user?")) return;
      try {
        const response = await deleteUser(authToken, id);
        if (response.Result) {
          alert("User Deleted");
          getAllUser();
        }
      } catch (error) {
        console.error("Error deleting user:", error);
      }
    };

    return (
      <div className="space-y-6 pb-8">
        {/* Header with Heading and Button */}
        <div className="glass-panel p-6 flex justify-between items-center">
          <div>
            <h1 className={`font-extrabold text-2xl sm:text-3xl ${isDark ? 'text-white' : 'text-slate-900'}`}>User Management</h1>
            <p className={`text-xs mt-1 ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>Manage system administrator accounts and permissions</p>
          </div>
          <button
            onClick={() => navigate('/users/createUser')}
            className="glass-btn-primary px-5 py-2.5 text-xs font-semibold"
          >
            + Create User
          </button>
        </div>

        {/* User Table Container */}
        <div className="glass-panel overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-full glass-table">
              <thead>
                <tr>
                  <th className="py-3.5 px-4 text-left font-semibold text-xs uppercase tracking-wider">ID</th>
                  <th className="py-3.5 px-4 text-left font-semibold text-xs uppercase tracking-wider">Email</th>
                  <th className="py-3.5 px-4 text-left font-semibold text-xs uppercase tracking-wider">Role</th>
                  <th className="py-3.5 px-4 text-center font-semibold text-xs uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.length > 0 ? (
                  users.map((user) => (
                    <tr key={user.id} className="transition-colors hover:bg-white/5">
                      <td className="py-3.5 px-4 text-xs font-mono font-semibold">{user.id}</td>
                      <td className="py-3.5 px-4 text-xs font-medium">{user.email}</td>
                      <td className="py-3.5 px-4 text-xs">
                        <span className={`px-2.5 py-1 rounded-full text-[11px] font-bold ${
                          user.role === 'SuperAdmin' ? 'bg-purple-500/20 text-purple-400 border border-purple-500/30' : 'bg-blue-500/20 text-blue-400 border border-blue-500/30'
                        }`}>
                          {user.role}
                        </span>
                      </td>
                      <td className="py-3.5 px-4 text-center space-x-2">
                        {user.role !== "SuperAdmin" && (
                          <>
                            <button
                              className="glass-btn-secondary px-3 py-1.5 text-xs font-medium"
                              onClick={() => navigate(`/users/editUser/${user.id}`, { state: { user } })}
                            >
                              Edit
                            </button>
                            <button
                              className="glass-btn-danger px-3 py-1.5 text-xs font-medium"
                              onClick={() => deleteAUser(user.id)}
                            >
                              Delete
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="py-8 text-center text-sm text-slate-400" colSpan="4">
                      No users found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
};

export default Users;